export default __webpack_public_path__ + "static/heroSectionImage-1491c2673f3e8ed090c15db8d83b4420.webp";